module.exports = __webpack_public_path__ + "img/Framed.6c059a39.svg";